<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EnquiryReservationForm
      :enquiryReservationData="enquiryReservationData"
      :submitName="$t('enquiryReservations.reserve')"
      v-on:addEnquiryReservation="addEnquiryReservation"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import EnquiryReservationForm from "@/components/reservations/enquiryReservations/EnquiryReservationForm.vue";
import EnquiryReservation from "@/models/reservations/enquiryReservations/EnquiryReservation";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "EnquiryReservationAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EnquiryReservationForm,
  },
  data() {
    return {
      isClient: false,
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      enquiryReservationData: new EnquiryReservation(),
      placeToken: this.$route.params.placeToken || "",
      placePartToken: this.$route.params.placePartToken || "",
    };
  },
  methods: {
    async setUserType() {
      if (this.$store.getters.userData.clientPersonalData) {
        this.isClient = true;
      }
    },
    async addEnquiryReservation() {
      this.isLoading = true;
      if (this.isClient) {
        this.enquiryReservations.filterData.clientToken =
          this.$store.getters.userData.clientPersonalData.clientToken;
      }
      try {
        let response = await this.enquiryReservationData.addEnquiryReservation(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.enquiryReservationData.setInitialValue();
          this.enquiryReservationData.placeToken =
            this.$route.params.placeToken;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    setPlaceToken() {
      this.enquiryReservationData.placeToken = this.placeToken;
    },
    setPlacePartToken() {
      this.enquiryReservationData.placePartToken = this.placePartToken;
    },
  },
  watch: {
    placeToken() {
      this.setPlaceToken();
    },
    placePartToken() {
      this.setPlacePartToken();
    },
  },
  async created() {
    this.setPlaceToken();
    this.setPlacePartToken();
    this.setUserType();
  },
};
</script>
